/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import IconTitleDescriptionList from "reusables/TextFormats/IconTitleDescriptionList";

// Images
import local from "assets/images/AboutUs/LocallyOperated.png";
import responsive from "assets/images/AboutUs/Responsive&Reliable.png";
import transparent from "assets/images/AboutUs/TransparentPricing.png";

function AboutUs_Section2() {
  const items = [
    {
      icon: "location_on",
      // image: local,
      title: "Locally Operated",
      description: "Serving Cork and Dublin with local expertise",
      gridRatio: [1, 11],
      color: "primary",
    },
    {
      icon: "support_agent",
      // image: responsive,
      title: "Responsive and Reliable",
      description: "Quick responses, flexible solutions",
      gridRatio: [1, 11],
      color: "primary",
    },
    {
      icon: "euro",
      // image: transparent,
      title: "Transparent Pricing",
      description: "Clear estimates, no hidden fees",
      gridRatio: [1, 11],
      color: "primary",
    },
  ];
  return (
    <Container>
      <SubTitleContents
        title="Why Choose Us?"
        contents={
          <>
            <Grid container alignItems="center">
              <Grid item xs={12} md={12} lg={4}>
                <IconTitleDescriptionList objsArray={items} />
              </Grid>
              <Grid item xs={12} md={12} lg={8}>
                Our team of fully trained and insured professionals is committed to delivering
                outstanding results using modern equipment and eco-friendly products. We offer
                tailored solutions for both domestic and commercial clients, including regular
                cleaning, deep cleaning, and move-in/move-out services. With a focus on punctuality,
                attention to detail, and exceptional customer care, we ensure every job is completed
                to the highest standard. Whether you need a free quote, want to book online, or
                prefer to chat with one of our friendly team members, we make the process smooth and
                hassle-free.
              </Grid>
            </Grid>
          </>
        }
      />
    </Container>
  );
}

export default AboutUs_Section2;

// /* eslint-disable no-unused-vars */
// import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";
// import Stack from "@mui/material/Stack";
// import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// // Material Kit 2 React components
// import MKBox from "components/MKBox";
// import MKTypography from "components/MKTypography";

// // Images
// import local from "assets/images/AboutUs/LocallyOperated.png";
// import responsive from "assets/images/AboutUs/Responsive&Reliable.png";
// import transparent from "assets/images/AboutUs/TransparentPricing.png";

// function AboutUs_Section2() {
//   return (
//     <Container>
//       <SubTitleContents
//         title="Why Choose Us?"
//         contents={
//           <>
//             <Grid container alignItems="center">
//               {/* <Grid container alignItems="center" sx={{ backgroundColor: "pink" }}> */}
//               <Grid item xs={12} lg={4}>
//                 <Stack>
//                   <MKBox
//                     display="flex"
//                     flexDirection="row"
//                     alignItems="center"
//                     pr={5}
//                     py={2}
//                     bgColor="yellow"
//                   >
//                     <MKBox
//                       width="20%"
//                       height="auto"
//                       // variant="gradient"
//                       // bgColor="primary"
//                       display="flex"
//                       alignItems="center"
//                       justifyContent="center"
//                       borderRadius="xl"
//                     >
//                       {/* <Icon fontSize="small">diversity_1</Icon> */}
//                       <MKBox
//                         component="img"
//                         src={local}
//                         // alt={name}
//                         width="100%"
//                         borderRadius="100%"
//                         shadow="lg"
//                         sx={{ zIndex: "10" }}
//                       />
//                     </MKBox>
//                     <MKBox display="flex" flexDirection="column" bgColor="lightblue">
//                       <MKBox>
//                         <MKTypography variant="body1" color="text" pl={2}>
//                           Locally Operated
//                         </MKTypography>
//                       </MKBox>
//                       <MKBox>
//                         <MKTypography variant="body2" color="text" pl={2}>
//                           Serving Cork and Dublin with local expertise
//                         </MKTypography>
//                       </MKBox>
//                     </MKBox>
//                   </MKBox>
//                   <MKBox display="flex" alignItems="center" pr={5} py={2}>
//                     <MKBox
//                       width="3rem"
//                       height="3rem"
//                       // variant="gradient"
//                       // bgColor="primary"
//                       // color="white"
//                       color="primary"
//                       // coloredShadow="dark"
//                       display="flex"
//                       // alignItems="center"
//                       justifyContent="center"
//                       borderRadius="xl"
//                     >
//                       {/* <Icon fontSize="small">volunteer_activism</Icon> */}
//                       <MKBox
//                         component="img"
//                         src={responsive}
//                         // alt={name}
//                         width="100%"
//                         borderRadius="100%"
//                         shadow="lg"
//                         sx={{ zIndex: "10" }}
//                       />
//                     </MKBox>
//                     <MKBox display="flex" flexDirection="column">
//                       <MKBox>
//                         <MKTypography variant="body1" color="text" pl={2}>
//                           Responsive and Reliable
//                         </MKTypography>
//                       </MKBox>
//                       <MKBox>
//                         <MKTypography variant="body2" color="text" pl={2}>
//                           Quick responses, flexible solutions
//                         </MKTypography>
//                       </MKBox>
//                     </MKBox>
//                   </MKBox>
//                   <MKBox display="flex" alignItems="center" pr={5} py={2}>
//                     <MKBox
//                       width="3rem"
//                       height="3rem"
//                       color="primary"
//                       display="flex"
//                       // alignItems="center"
//                       justifyContent="center"
//                       borderRadius="xl"
//                     >
//                       {/* <Icon fontSize="small">sentiment_satisfied</Icon> */}
//                       <MKBox
//                         component="img"
//                         src={transparent}
//                         // alt={name}
//                         width="100%"
//                         borderRadius="100%"
//                         shadow="lg"
//                         sx={{ zIndex: "10" }}
//                       />
//                     </MKBox>
//                     <MKBox display="flex" flexDirection="column">
//                       <MKBox>
//                         <MKTypography variant="body1" color="text" pl={2}>
//                           Transparent Pricing
//                         </MKTypography>
//                       </MKBox>
//                       <MKBox>
//                         <MKTypography variant="body2" color="text" pl={2}>
//                           Clear estimates, no hidden fees
//                         </MKTypography>
//                       </MKBox>
//                     </MKBox>
//                   </MKBox>
//                 </Stack>
//               </Grid>
//               <Grid item xs={12} lg={8} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 3, lg: 0 } }}>
//                 Our team of fully trained and insured professionals is committed to delivering
//                 outstanding results using modern equipment and eco-friendly products. We offer
//                 tailored solutions for both domestic and commercial clients, including regular
//                 cleaning, deep cleaning, and move-in/move-out services. With a focus on punctuality,
//                 attention to detail, and exceptional customer care, we ensure every job is completed
//                 to the highest standard. Whether you need a free quote, want to book online, or
//                 prefer to chat with one of our friendly team members, we make the process smooth and
//                 hassle-free.
//               </Grid>
//             </Grid>
//           </>
//         }
//       />
//     </Container>
//   );
// }

// export default AboutUs_Section2;
